import React, {useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import * as LotteryActions from '../../actions/LotteryActions'
import {Accordion, Form, Table, Popup, Icon, Loader, Button, Menu} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import * as moment from 'moment'
import * as Settings from './Settings';

const _ = require('lodash');

export const Sidebar = (props) => {
    moment.locale('de');

    return (
        <div style={{
            flexGrow: 0,
            width: '300px',
            backgroundColor: '#F4F4F4',
            marginRight: '4em',
            padding: '1em',
            overflow: 'auto'
        }}>
            <Accordion>
                <Settings.Category readonly={props.readonly} />
                <Settings.Teaser readonly={props.readonly} />
                <Settings.Notification readonly={props.readonly} storyId={props.storyId} draftId={props.draftId} />
                <Settings.Timespans readonly={props.readonly} />
                <Settings.Channels readonly={props.readonly} />                    
            </Accordion>
        </div>
    )
}